import { moveToFulfilled, moveToPending, moveToRejected, update } from '@ms/yammer-data-support';
import { BulkAddUsersToGroupAsyncStatus } from '@ms/yammer-graphql';
import type { Reducer } from 'redux';

import type {
  GroupMembersBulkImportAbortFulfilledAction,
  GroupMembersBulkImportStatusAction,
} from '../../domains/groupMembersBulkUpload/actions.types';

import type { GroupMembersBulkImportStatuses } from './types';

const initialState: GroupMembersBulkImportStatuses = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

export type GroupMembersBulkImportAction =
  | GroupMembersBulkImportStatusAction
  | GroupMembersBulkImportAbortFulfilledAction;

const reducer: Reducer<GroupMembersBulkImportStatuses, GroupMembersBulkImportAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case 'GROUP_MEMBERS.BULK_IMPORT_STATUS_PENDING':
      return moveToPending(state, [action.payload.groupId]);
    case 'GROUP_MEMBERS.BULK_IMPORT_STATUS_REJECTED':
      return moveToRejected(state, [action.payload.groupId], action.payload.error);
    case 'GROUP_MEMBERS.BULK_IMPORT_STATUS_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.groupMembersBulkImportStatus);
    case 'GROUP_MEMBERS.BULK_IMPORT_ABORT_FULFILLED':
      return update(state, action.payload.groupId, { status: BulkAddUsersToGroupAsyncStatus.ABORTED });
    default:
      return state;
  }
};
export default reducer;
